import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader'
import ExpenseRegisterModal from './ExpenseRegisterModal'
import ExpenseRegisterGrid from './ExpenseRegisterGrid'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import { getStorageValues } from '../../shared/CommonFunctions'
import { getModulePermissions } from '../../utils/permissionHelper'
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles'
import { logAuditEvent } from '../../utils/auditLogger'
import { fetchExpenseRegisterList, saveExpenseRegister } from '../../utils/expenseRegisterApi'

function ExpenseRegisterMain(props) {
  const [expenseRegisterList, setExpenseRegisterList] = useState([])
  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [alert, setAlert] = useState(null)
  const [userModulePermission, setUserModulePermission] = React.useState([])
  const moduleName = props.Module || 'Expense Register'

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module)
    setUserModulePermission(modulePermissions ? modulePermissions : [])
    fetchExpenseRegisters()
  }, [props.Module])

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', `Accessed ${moduleName}`)
  }, [moduleName])

  function openAddModal() {
    setIsOpen(true)
    logAuditEvent(moduleName, 'Add Button Click', `Opened add ${moduleName} modal`)
  }

  function closeModal() {
    setIsOpen(false)
  }

  async function onSubmit(e, data) {
    if (e.target.name === 'Add') {
      const expenseRegisterModel = data
      if (expenseRegisterModel) {
        let expenseRegisterDetails = {
          ExpenseRegisterId: null,
          ExpenseCategoryId: expenseRegisterModel.ExpenseCategoryId || null,
          ExpenseDate: expenseRegisterModel.ExpenseDate || null,
          Amount: expenseRegisterModel.Amount || null,
          ReferenceNo: expenseRegisterModel.ReferenceNo || '',
          ExpenseFor: expenseRegisterModel.ExpenseFor || '',
          Description: expenseRegisterModel.Description || '',
          UserId: getStorageValues('userId')
        }
        if (validation(expenseRegisterDetails)) {
          try {
            const response = await saveExpenseRegister(expenseRegisterDetails)
            if (response?.success) {
              if (response?.data?.success === 1 || response?.data?.success === undefined) {
                CreateAlert(response?.data?.message || 'Expense register added successfully!!', 'Success', setAlert)
                fetchExpenseRegisters()
                closeModal()
              } else {
                CreateAlert(response?.data?.message || 'Unable to save record', 'Error', setAlert)
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
      } else {
        CreateAlert('Fields marked with an asterisk (*) are required!!', 'Error', setAlert)
      }
    }
  }

  function validation(expenseRegisterDetails) {
    let isValid = true
    if (expenseRegisterDetails) {
      if (!expenseRegisterDetails.ExpenseCategoryId) {
        CreateAlert('Please select expense category!!', 'Warning', setAlert)
        return false
      }
      if (!expenseRegisterDetails.ExpenseDate) {
        CreateAlert('Please select expense date!!', 'Warning', setAlert)
        return false
      }
      const amountValue = Number(expenseRegisterDetails.Amount)
      if (!expenseRegisterDetails.Amount || Number.isNaN(amountValue) || amountValue <= 0) {
        CreateAlert('Please enter valid amount!!', 'Warning', setAlert)
        return false
      }
      if ((expenseRegisterDetails.Description || '').length > 600) {
        CreateAlert('Description can be maximum 600 characters!!', 'Warning', setAlert)
        return false
      }
    } else {
      CreateAlert('Some problem fetching details entered by the user!!', 'Error', setAlert)
      isValid = false
      return
    }
    return isValid
  }

  const fetchExpenseRegisters = async () => {
    try {
      const records = await fetchExpenseRegisterList({ userId: getStorageValues('userId') })
      setExpenseRegisterList(records)
    } catch (error) {
      console.log(error)
    }
  }

  const handleExportExcel = () => {
    const columns = [
      { name: 'Expense Category', selector: 'ExpenseCategoryName' },
      { name: 'Expense Date', selector: 'ExpenseDate' },
      { name: 'Amount', selector: 'Amount' },
      { name: 'Reference', selector: 'ReferenceNo' },
      { name: 'Expense For', selector: 'ExpenseFor' },
      { name: 'Description', selector: 'Description' }
    ]
    exportToExcel('ExpenseRegister', columns, expenseRegisterList)
  }

  const handleExportPDF = () => {
    const columns = [
      { name: 'Expense Category', selector: 'ExpenseCategoryName' },
      { name: 'Expense Date', selector: 'ExpenseDate' },
      { name: 'Amount', selector: 'Amount' },
      { name: 'Reference', selector: 'ReferenceNo' },
      { name: 'Expense For', selector: 'ExpenseFor' },
      { name: 'Description', selector: 'Description' }
    ]
    exportToPDF('ExpenseRegister', columns, expenseRegisterList)
  }

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal}
        onRefresh={fetchExpenseRegisters}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={userModulePermission.AddModule === 1 ? true : false}
      />
      <ExpenseRegisterGrid
        ExpenseRegisterData={expenseRegisterList}
        fetchExpenseRegisters={fetchExpenseRegisters}
        UserPermissions={userModulePermission}
        moduleName={moduleName}
      />
      <ExpenseRegisterModal
        show={modalIsOpen}
        UserAction={'Add'}
        onClose={closeModal}
        onSubmit={onSubmit}
        moduleName={moduleName}
      />
    </>
  )
}

export default ExpenseRegisterMain
